/**
 * @fileoverview
 * Utility function to detect locale from the browser setting or parameter on the URL.
 * URL 参数 lang 优先：可选值 en、zh、zhHant，分别对应 en、zh-cn、zh-tw。
 */

import queryString from 'query-string';

/** lang 参数值到实际 locale 的映射（en、zh、zhHant） */
const LANG_TO_LOCALE = {
    en: 'en',
    zh: 'zh-cn',
    zhhant: 'zh-tw',
    'zh-hant': 'zh-tw'
};

/**
 * Look for language setting: first URL lang= (en | zh | zhHant), then browser.
 * @param {Array.string} supportedLocales An array of supported locale codes.
 * @return {string} the preferred locale
 */
const detectLocale = supportedLocales => {
    const queryParams = queryString.parse(location.search);
    const langParam = queryParams.lang;
    if (langParam) {
        const raw = String(langParam).toLowerCase();
        const normalized = raw.replace(/_/g, '-');
        const mapped = LANG_TO_LOCALE[normalized] || LANG_TO_LOCALE[raw.replace(/-/g, '')];
        const urlLocale = mapped || normalized;
        if (supportedLocales.includes(urlLocale)) {
            return urlLocale;
        }
    }

    let locale = 'en';
    const browserLocale = (window.navigator.userLanguage || window.navigator.language || '').toLowerCase();
    if (supportedLocales.includes(browserLocale)) {
        locale = browserLocale;
    } else {
        const browserLang = browserLocale.split('-')[0];
        if (supportedLocales.includes(browserLang)) {
            locale = browserLang;
        }
    }

    const potentialLocales = [].concat(queryParams.locale, queryParams.lang).filter(l => l);
    if (potentialLocales.length) {
        const urlLocale = potentialLocales[0].toLowerCase();
        if (supportedLocales.includes(urlLocale)) {
            return urlLocale;
        }
    }

    return locale;
};

export {
    detectLocale
};
